import { render, staticRenderFns } from "./ProjectShellComponent.vue?vue&type=template&id=59810aa3&scoped=true"
import script from "./ProjectShellComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectShellComponent.vue?vue&type=script&lang=ts"
import style0 from "./ProjectShellComponent.vue?vue&type=style&index=0&id=59810aa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59810aa3",
  null
  
)

export default component.exports